import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setRegions,
  setProvincies,
  setCities,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure
} from "./regionSlice";
import regionAPI from "../../services/regionAPI";

// Fetch all regions
export const fetchRegions = createAsyncThunk(
  "regionData/fetchRegions",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await regionAPI.getAllRegions();
      dispatch(setRegions(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch regions.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch provincies for a specific region
export const fetchProvincies = createAsyncThunk(
  "regionData/fetchProvincies",
  async (regionsId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await regionAPI.getProvincies(regionsId);
      dispatch(setProvincies(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch provincies.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch cities for a specific region and province
export const fetchCities = createAsyncThunk(
  "regionData/fetchCities",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await regionAPI.getCities();
      console.log("response.data.data", response.data.data)
      dispatch(setCities(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch cities.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);